{
  "name": "@epg-apps/source",
  "version": "0.1.0-1113-20260519123127",
  "license": "MIT",
  "scripts": {
    "cdh-new": "nx run cdh-new:serve:development-nl",
    "cdh-new-nl": "nx run cdh-new:serve:development-nl --port=4201",
    "cdh-new-fr": "nx run cdh-new:serve:development-fr --port=4202",
    "cdh-new:local": "nx run cdh-new:serve:local",
    "cdh-new:dev": "nx run cdh-new:serve:dev",
    "cdh-new:acc": "nx run cdh-new:serve:acc",
    "cdh-new:e2e": "nx serve cdh-e2e",
    "cdh-new:extract-i18n": "nx run cdh-new:extract-i18n",
    "cdh-new-local-swa": "swa start dist/apps/cdh-new/browser --config staticwebapp.config.json --port=4200",
    "cdh-new:build:local": "nx run cdh-new:extract-i18n && nx run cdh-new:build --configuration=local",
    "cdh-new:build:dev": "nx run cdh-new:extract-i18n && nx run cdh-new:build --configuration=development && nx run cdh-new:copy-assets",
    "cdh-new:build:acc": "nx run cdh-new:extract-i18n && nx run cdh-new:build --configuration=acc && nx run cdh-new:copy-assets",
    "cdh-new:build:prod": "nx run cdh-new:extract-i18n && nx run cdh-new:build --configuration=production && nx run cdh-new:copy-assets",
    "playground": "nx serve playground",
    "ui-color-systems": "nx serve ui-color-systems",
    "multiple-apps": "nx run-many -t serve -p ui-color-systems cdh",
    "test-all": "nx run-many --all --target=test",
    "test-changed": "nx affected -t test ",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.6",
    "@angular/cdk": "21.2.4",
    "@angular/common": "21.2.6",
    "@angular/compiler": "21.2.6",
    "@angular/core": "21.2.6",
    "@angular/forms": "21.2.6",
    "@angular/localize": "21.2.6",
    "@angular/material": "21.2.4",
    "@angular/platform-browser": "21.2.6",
    "@angular/platform-browser-dynamic": "21.2.6",
    "@angular/router": "21.2.6",
    "@ngx-formly/core": "^7.1.0",
    "@ngx-formly/material": "7.1.0",
    "@ngx-translate/core": "15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "ngx-cookie-service": "^21.3.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "~2.1.2",
    "@analogjs/vitest-angular": "~2.1.2",
    "@angular-devkit/build-angular": "21.2.3",
    "@angular-devkit/core": "21.2.3",
    "@angular-devkit/schematics": "21.2.3",
    "@angular-eslint/eslint-plugin": "21.3.1",
    "@angular-eslint/eslint-plugin-template": "21.3.1",
    "@angular-eslint/schematics": "21.3.1",
    "@angular-eslint/template-parser": "21.3.1",
    "@angular/build": "21.2.3",
    "@angular/cli": "21.2.3",
    "@angular/compiler-cli": "21.2.6",
    "@angular/language-service": "21.2.6",
    "@azure/static-web-apps-cli": "^2.0.8",
    "@eslint/eslintrc": "^2.1.4",
    "@eslint/js": "~8.57.0",
    "@nx/angular": "~22.6.3",
    "@nx/devkit": "~22.5.4",
    "@nx/eslint": "~22.5.4",
    "@nx/eslint-plugin": "~22.5.4",
    "@nx/js": "22.6.5",
    "@nx/playwright": "~22.5.4",
    "@nx/plugin": "22.5.4",
    "@nx/vite": "22.5.4",
    "@nx/vitest": "22.5.4",
    "@nx/web": "22.6.5",
    "@nx/workspace": "~22.5.4",
    "@oxc-project/runtime": "^0.115.0",
    "@playwright/test": "^1.58.2",
    "@schematics/angular": "19.2.22",
    "@swc-node/register": "~1.11.1",
    "@swc/cli": "~0.8.0",
    "@swc/core": "~1.15.18",
    "@swc/helpers": "^0.5.20",
    "@types/node": "20.19.9",
    "@typescript-eslint/utils": "^8.57.2",
    "@vitest/coverage-v8": "^4.0.0",
    "@vitest/ui": "^4.0.0",
    "angular-eslint": "^21.2.0",
    "autoprefixer": "^10.4.0",
    "cpx": "^1.5.0",
    "eslint": "9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-playwright": "^1.8.3",
    "eslint-plugin-prettier": "^5.5.5",
    "husky": "^9.1.7",
    "jiti": "2.4.2",
    "jsdom": "^27.1.0",
    "jsonc-eslint-parser": "^2.4.2",
    "lint-staged": "^16.4.0",
    "ng-packagr": "21.2.2",
    "nx": "~22.5.4",
    "postcss": "^8.5.8",
    "postcss-url": "~10.1.3",
    "prettier": "3.8.1",
    "ts-jest": "^29.4.6",
    "ts-node": "10.9.2",
    "typescript": "5.9.3",
    "typescript-eslint": "^8.57.2",
    "vite": "^7.0.0",
    "vitest": "^4.0.0"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "lint-staged": {
    "*.{ts,js}": [
      "eslint --fix",
      "prettier --write"
    ],
    "*.{html,css,scss,json,md}": [
      "prettier --write"
    ]
  }
}
